import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import LoadingSpinner from "./LoadingSpinner";
import { getToken, getRole } from "../services/authStorage";
import { normalizeRole, roleMatches } from "../utils/roles";

/**
 * PrivateRoute
 *  - Requires an active session token (sessionStorage)
 *  - Waits for AuthContext to resolve /auth/me to avoid false redirects
 *  - Optionally gates by role via `allowedRoles`
 */
const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useContext(AuthContext);

  const token = getToken();
  const effectiveRole = normalizeRole(user?.role || getRole());

  // Wait for /auth/me
  if (loading) return <LoadingSpinner />;

  // Not logged in
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Role-restricted route
  if (allowedRoles.length > 0 && !roleMatches(effectiveRole, allowedRoles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivateRoute;
